Ember.TEMPLATES["controls/replace_with_browse"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data
) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, hashTypes, hashContexts, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  hashTypes = {};
  hashContexts = {};
  options = {hash:{},contexts:[depth0],types:["ID"],hashContexts:hashContexts,hashTypes:hashTypes,data:data};
  data.buffer.push(escapeExpression(((stack1 = helpers['t'] || depth0['t']),stack1 ? stack1.call(depth0, "instructions.upload_your_own_image", options) : helperMissing.call(depth0, "t", "instructions.upload_your_own_image", options))));
  data.buffer.push("\n<div class=\"vr-file-upload-form\">\n  <div class=\"vr-upload-dialog\">\n    <input type=\"file\" id=\"file-upload\" name=\"image\" />\n  </div>\n</div>\n");
  return buffer;
  
});